/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Ai_DescriptionInputs */

const en_marketing_feature_ai_description = /** @type {(inputs: Marketing_Feature_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A chat agent on the Cloudflare Agents SDK, shipped as a working paid feature.`)
};

const es_marketing_feature_ai_description = /** @type {(inputs: Marketing_Feature_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un agente de chat sobre el Agents SDK de Cloudflare, listo como función de pago.`)
};

const fr_marketing_feature_ai_description = /** @type {(inputs: Marketing_Feature_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un agent conversationnel sur l'Agents SDK de Cloudflare, livré comme fonctionnalité payante opérationnelle.`)
};

/**
* | output |
* | --- |
* | "A chat agent on the Cloudflare Agents SDK, shipped as a working paid feature." |
*
* @param {Marketing_Feature_Ai_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_ai_description = /** @type {((inputs?: Marketing_Feature_Ai_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Ai_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_ai_description(inputs)
	if (locale === "es") return es_marketing_feature_ai_description(inputs)
	return fr_marketing_feature_ai_description(inputs)
});